import script from "./RegisterContent.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterContent.vue?vue&type=script&setup=true&lang=js"

import "./RegisterContent.vue?vue&type=style&index=0&id=bfdbbf22&lang=css"
import "./RegisterContent.vue?vue&type=style&index=1&id=bfdbbf22&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bfdbbf22"]])

export default __exports__